import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import IconButton from '../../components/icon-button';
import caretWhiteLeft from '../../assets/images/caret-white-left.svg';
import Carousel from 'nuka-carousel';
import caretLeft from '../../assets/images/caret-left.svg';
import styles from './styles.module.scss';

const ImageObject = () => {
  const state = useLocation().state;
  const navigate = useNavigate();
  const isCarouselInDetails = !!state?.images;
  const imageHeight = 200;
  const [index, setIndex] = useState(0);

  const handleLeftButton = (previousSlide: any) => {
    previousSlide();
  };
  const handleRightButton = (nextSlide: any) => {
    nextSlide();
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.headerWrapper}>
          <IconButton icon={caretWhiteLeft} onClick={() => navigate(-1)} />
        </div>
      </header>

      {isCarouselInDetails ? (
        <div className={styles.containerCarousel}>
          <Carousel
            swiping={false} // Disable swiping
            wrapAround
            enableKeyboardControls
            afterSlide={setIndex}
            disableEdgeSwiping={true}
            dragging={false}
            className={styles.carousel}
            defaultControlsConfig={{ pagingDotsStyle: { display: 'none' } }}
            renderCenterLeftControls={({ previousSlide }) => (
              <IconButton
                className={styles.leftIcon}
                icon={caretLeft}
                onClick={() => handleLeftButton(previousSlide)}
              />
            )}
            renderCenterRightControls={({ nextSlide }) => (
              <IconButton
                className={styles.rightIcon}
                icon={caretLeft}
                onClick={() => handleRightButton(nextSlide)}
              />
            )}
          >
            {state?.images?.map((i: any, idx: any) => (
              <img src={i.src} alt={i.alt} key={idx} height={imageHeight} onClick={() => {}} />
            ))}
          </Carousel>

          <div className={styles.pageInfo}>{index + 1 + '/' + state?.images.length}</div>
        </div>
      ) : (
        <img src={state?.src} alt={state?.alt} key={1} />
      )}
    </div>
  );
};

export default ImageObject;
